// это хешированные id_H айдишники кастомников с бэка, если они там поменяются, здесь тоже надо менять
export default {
  preorder: 'O2m',
  inviterGf: 'nPV',
  inviterSf: '2J8',
  inviterRegions: '1ob',
}
